/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { OdataSachbearbeiterPersonResponse } from '../models/odata-sachbearbeiter-person-response';
import { OdataAllSachbearbeiterRequest } from '../models/odata-all-sachbearbeiter-request';
import { OdataSachbearbeiterResponse } from '../models/odata-sachbearbeiter-response';
import { OdataSachbearbeiterRequest } from '../models/odata-sachbearbeiter-request';
@Injectable({
  providedIn: 'root',
})
class SachbearbeiterService extends __BaseService {
  static readonly sachbearbeiterOdataAllPersonenRetrieveCreatePath = '/sachbearbeiter/odata/all/personen/retrieve';
  static readonly sachbearbeiterOdataAllRetrieveCreatePath = '/sachbearbeiter/odata/all/retrieve';
  static readonly sachbearbeiterOdataRetrieveCreatePath = '/sachbearbeiter/odata/retrieve';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param data undefined
   */
  sachbearbeiterOdataAllPersonenRetrieveCreateResponse(data: OdataAllSachbearbeiterRequest): __Observable<__StrictHttpResponse<Array<OdataSachbearbeiterPersonResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/sachbearbeiter/odata/all/personen/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<OdataSachbearbeiterPersonResponse>>;
      })
    );
  }
  /**
   * @param data undefined
   */
  sachbearbeiterOdataAllPersonenRetrieveCreate(data: OdataAllSachbearbeiterRequest): __Observable<Array<OdataSachbearbeiterPersonResponse>> {
    return this.sachbearbeiterOdataAllPersonenRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as Array<OdataSachbearbeiterPersonResponse>)
    );
  }

  /**
   * @param data undefined
   */
  sachbearbeiterOdataAllRetrieveCreateResponse(data: OdataAllSachbearbeiterRequest): __Observable<__StrictHttpResponse<Array<OdataSachbearbeiterResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/sachbearbeiter/odata/all/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<OdataSachbearbeiterResponse>>;
      })
    );
  }
  /**
   * @param data undefined
   */
  sachbearbeiterOdataAllRetrieveCreate(data: OdataAllSachbearbeiterRequest): __Observable<Array<OdataSachbearbeiterResponse>> {
    return this.sachbearbeiterOdataAllRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as Array<OdataSachbearbeiterResponse>)
    );
  }

  /**
   * @param data undefined
   */
  sachbearbeiterOdataRetrieveCreateResponse(data: OdataSachbearbeiterRequest): __Observable<__StrictHttpResponse<OdataSachbearbeiterResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/sachbearbeiter/odata/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataSachbearbeiterResponse>;
      })
    );
  }
  /**
   * @param data undefined
   */
  sachbearbeiterOdataRetrieveCreate(data: OdataSachbearbeiterRequest): __Observable<OdataSachbearbeiterResponse> {
    return this.sachbearbeiterOdataRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as OdataSachbearbeiterResponse)
    );
  }
}

module SachbearbeiterService {
}

export { SachbearbeiterService }
